import { render, staticRenderFns } from "./DSPplorder.vue?vue&type=template&id=685eea66&scoped=true"
import script from "./DSPplorder.vue?vue&type=script&lang=js"
export * from "./DSPplorder.vue?vue&type=script&lang=js"
import style0 from "./DSPplorder.vue?vue&type=style&index=0&id=685eea66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685eea66",
  null
  
)

export default component.exports